'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var CurrencyColors = require('./CurrencyColors.js');

class CurrencyColorProvider {
    static getCurrencyColor(currency) {
        return CurrencyColors["default"][currency];
    }
}

exports["default"] = CurrencyColorProvider;
